<ng-container *ngIf="inProgress">
  <mat-progress-bar *ngIf="indicatorType === INDICATOR_TYPE_BAR" mode="indeterminate"
                    color="accent"></mat-progress-bar>
  <mat-spinner *ngIf="indicatorType === INDICATOR_TYPE_SPINNER" mode="indeterminate"
               color="accent"></mat-spinner>
  <div class="progress-overlay-shadow">
    <div class="progress-text-container">
      <h2 class="progress-text">{{progressText}}</h2>
    </div>
  </div>
</ng-container>
